module.exports = __webpack_public_path__ + "img/MCD_FutureConcepts_Half_Teaser_01.c385c35d.jpg";